import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  // LumenForge branded toast — deep navy card, blue accent bar, white type.
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      className="toaster group lf-toaster"
      style={{ pointerEvents: 'auto' }}
      toastOptions={{
        duration: 3000,
        style: {
          background: "linear-gradient(135deg,#0f1220 0%,#141830 100%)",
          border: "1px solid rgba(59,130,246,0.35)",
          borderLeft: "3px solid #3b82f6",
          color: "#f5f7fb",
          boxShadow: "0 12px 30px rgba(6,10,30,0.55), 0 0 0 1px rgba(255,255,255,0.03) inset",
          borderRadius: 10,
          padding: "12px 16px",
          fontSize: "0.86rem",
          fontWeight: 500,
          letterSpacing: "0.005em",
        },
        classNames: {
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "lf-toast-success",
          error: "lf-toast-error",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
